<template>
  <div class="add-benefit-container">
    <el-dialog
      class="add-benefit-dialog"
      :title="titleMap[controlType]"
      :visible.sync="dialogVisible"
      width="680px"
      @close="onClose"
    >
      <div class="add-benefit-content">
        <el-form
          :model="formData"
          ref="the-form"
          label-width="150px"
          class="demo-formData"
        >
          <el-form-item label="权益名称" required>
            <el-input
              class="w470"
              v-model="formData.name"
              type="text"
              placeholder="请输入名称"
              maxlength="10"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="跳转链接">
            <el-input
              class="w470"
              v-model="formData.jumpInfo"
              type="text"
              placeholder="请输入"
              maxlength="9999"
              show-word-limit
            ></el-input>
            <div
              class="jump-toggle"
              v-if="[1, 2, 4, 5].includes(formData.jumpType)"
            >
              <el-form-item
                v-if="formData.jumpType === 1"
                label="选择活动："
                required
                label-width="96px"
                style="margin-top: 18px"
              >
                <dy-button type="blue" @click="isShowActivity = true"
                  >选择活动</dy-button
                ><span>{{
                  selectActivityItem.activityName || "这里显示已选择的活动名称"
                }}</span>
              </el-form-item>
              <el-form-item
                v-if="formData.jumpType == 2"
                label="商品ID："
                required
                label-width="110px"
                style="margin-top: 18px"
              >
                <el-input
                  v-model="formData.jumpInfo"
                  type="text"
                  style="width: 260px"
                  placeholder="必填，请输入一个商品ID"
                ></el-input>
              </el-form-item>
              <el-form-item
                v-if="formData.jumpType == 4"
                label="主播抖音号："
                required
                label-width="110px"
                style="margin-top: 18px"
              >
                <el-input
                  v-model="formData.jumpInfo"
                  type="text"
                  style="width: 260px"
                  placeholder="必填，请输入抖音号"
                ></el-input
                ><span class="helper" @click="openHelp">操作指引</span>
              </el-form-item>
              <el-form-item
                v-if="formData.jumpType == 5"
                label="小程序页面路径："
                required
                label-width="136px"
                style="margin-top: 18px"
              >
                <el-input
                  v-model="formData.jumpInfo"
                  type="text"
                  style="width: 260px"
                  placeholder="必填，请输入小程序页面路径"
                ></el-input
                ><span class="helper" @click="isShowHelper = !isShowHelper"
                  >操作指引</span
                >
              </el-form-item>
            </div>
          </el-form-item>

          <el-form-item
            label="权益icon(已激活)："
            style="margin-right: 50px"
            required
          >
            <div class="unload-content flexc-cen-x">
              <el-upload
                :class="[
                  'img-uploader',
                  activeFileList.length ? 'hide-upload-btn' : '',
                ]"
                action="/api/image/upload"
                :file-list="activeFileList"
                list-type="picture-card"
                :on-success="handleActiveSuccess"
                :before-upload="beforeActiveUpload"
                :on-preview="handlePictureCardPreview"
                :on-remove="onActiveRemove"
              >
                <i class="el-icon-plus img-uploader-icon"></i>
              </el-upload>
              <div class="unload-tip flexc-cen-x">
                <span>建议尺寸：88*88px</span>
                <span>格式：jpg、png</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            label="权益icon(未激活)："
            style="margin-right: 50px"
            required
          >
            <div class="unload-content flexc-cen-x">
              <el-upload
                :class="[
                  'img-uploader',
                  disabledFileList.length ? 'hide-upload-btn' : '',
                ]"
                action="/api/image/upload"
                :file-list="disabledFileList"
                list-type="picture-card"
                :on-success="handleDefaultSuccess"
                :before-upload="beforeDefaultUpload"
                :on-preview="handlePictureCardPreview"
                :on-remove="onDefaultRemove"
              >
                <i class="el-icon-plus img-uploader-icon"></i>
              </el-upload>
              <div class="unload-tip flexc-cen-x">
                <span>建议尺寸：88*88px</span>
                <span>格式：jpg、png</span>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
     <div style="text-align:right">
        <el-button class="backBtn" @click="onClose">取消</el-button>
        <el-button type="primary"  @click="onSubmit" :loading="submitLoading"
          >确定</el-button
        >
     </div>
 
 
    </el-dialog>

    <!-- 选择活动 -->
    <select-activity v-model="isShowActivity" @select="onActivitySelect" />
    <!-- 展示操作指引 -->
    <helper v-model="isShowHelper" />

    <el-dialog
      :visible.sync="previewDialogVisible"
      :show-close="false"
      class="preview-dialog"
      width="100px"
    >
      <template #title></template>
      <img class="img" width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { modifyData } from "../../../utils/commonUtilt.js";
import {
    createMemberBenefitInfo,
} from "@/api/integralCenter/level";
const useFormData = () => {
  return {
    name: "",
    jumpType: -1,
    jumpInfo: "",
    benefitDisableIconUrl: "",
    benefitEnableIconUrl: "",
  };
};
/**
 *添加/编辑权益
 */
export default {
  name: "AddBenefit",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    controlType: {
      type: String,
      default: "",
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: false,
      titleMap: {
        add: "添加权益",
        edit: "编辑权益",
      },
      jumpTypeoptions: [
        { value: -1, label: "不跳转" },
        { value: 0, label: "跳转店铺首页" },
        { value: 1, label: "跳转活动页" },
        { value: 2, label: "跳转商品详情页" },
        { value: 3, label: "跳转会员中心页" },
        { value: 4, label: "跳转直播间" },
        { value: 5, label: "跳转小程序页面路径" },
      ],
      formData: useFormData(),
      submitLoading: false,

      activeFileList: [],
      disabledFileList: [],

      isShowActivity: false,
      selectActivityItem: {}, //选择的活动信息
      isShowHelper: false, //操作指引

      previewDialogVisible: false,
      dialogImageUrl: "",
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
      this.activeFileList = [];
      this.disabledFileList = [];
      this.selectActivityItem = {};
      if (val) {
        this.formData = useFormData();
        if (this.controlType == "edit") {
          let formData = this.formData;
          modifyData(formData, this.rowData);
          this.formData = formData;
          this.activeFileList = this.rowData.benefitEnableIconUrl
            ? [{ url: this.rowData.benefitEnableIconUrl }]
            : [];
          this.disabledFileList = this.rowData.benefitDisableIconUrl
            ? [{ url: this.rowData.benefitDisableIconUrl }]
            : [];
          if (this.formData.jumpType == 1) {
            let info = JSON.parse(this.rowData.jumpInfo);
            this.selectActivityItem = {
              id: info.activityId,
              activityType: info.activityType,
              activityName: info.activityName,
            };
          }
        }
      }
    },
  },
  methods: {
    onTypeChange() {
      this.selectActivityItem = {};
      this.formData.jumpInfo = "";
    },
    onClose() {
      this.$emit("input", false);
    },
    async onSubmit() {
      if (!this.formData.name) {
        return this.$message.warning("权益名称不可为空");
      }
      if (!this.activeFileList.length) {
        return this.$message.warning("权益icon(已激活)不可为空");
      }
      if (!this.disabledFileList.length) {
        return this.$message.warning("权益icon(未激活)不可为空");
      }
      console.log("通过校验");
      console.log("formData>>", this.formData);
      try {
        let params = {
          ...this.formData,
        };
        if (this.controlType == "edit") params.id = this.rowData.id;
        this.submitLoading = true;
        const res = await createMemberBenefitInfo(params);
        this.submitLoading = false;
        if (res.code == 1) {
          this.$message.success(
            this.controlType == "edit" ? "编辑成功" : "添加成功"
          );
          this.onClose();
          this.$emit("update");
        }
      } catch (err) {
        this.submitLoading = false;
      }
    },

    onActivitySelect(info) {
      this.selectActivityItem = { ...info };
      this.formData.linkActivityId = info.id;
      console.log("info>>", info);
    },

    openHelp() {
      window.open(
        "https://nvux21psg6t.feishu.cn/wiki/PFUzw4Q3HiGDg7k93g2cYETMnHg",
        "_blank"
      );
    },

    beforeActiveUpload(file) {
      console.log("file>>", file);
      const isJPG = ["image/jpeg", "image/png"].includes(file.type);
      let isLt300 = file.size / 1024 <= 300;
      if (!isJPG) {
        this.$message.info("权益icon（激活）图片格式不符合要求，请重新上传!");
        this.activeFileList = [];
      }
      if (!isLt300) {
        this.$message.info("权益icon（激活）图片大小不符合要求，请重新上传!");
        this.activeFileList = [];
      }
      return isJPG & isLt300;
    },

    onActiveRemove() {
      this.activeFileList = [];
    },

    handleActiveSuccess(res, file) {
      this.formData.benefitEnableIconUrl = res.data;
      this.activeFileList = [{ url: res.data }];
    },

    beforeDefaultUpload(file) {
      console.log("file>>", file);
      const isJPG = ["image/jpeg", "image/png"].includes(file.type);
      let isLt300 = file.size / 1024 <= 300;
      if (!isJPG) {
        this.$message.info("权益icon（未激活）图片格式不符合要求，请重新上传!");
        this.disabledFileList = [];
      }
      if (!isLt300) {
        this.$message.info("权益icon（未激活）图片大小不符合要求，请重新上传!");
        this.disabledFileList = [];
      }
      return isJPG && isLt300;
    },

    handleDefaultSuccess(res, file) {
      this.formData.benefitDisableIconUrl = res.data;
      this.disabledFileList = [{ url: res.data }];
    },

    onDefaultRemove() {
      this.disabledFileList = [];
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.previewDialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.w470 {
  width: 470px;
}
/deep/ .el-input__inner {
  width: 470px;
}
/deep/.el-dialog__footer {
  padding-top: 18px !important;
  border-top: 1px solid #f2f2f2;
}
.add-benefit-container {
  .add-benefit-dialog {
    .jump-toggle {
      width: 470px;
      height: 60px;
      display: flex;
      align-items: center;
      background-color: #f7f8fa;
      margin-top: 16px;

      /deep/ .el-input__inner {
        width: 260px !important;
      }

      .helper {
        font-size: 12px;
        color: #3159ff;
        cursor: pointer;
      }

      span {
        margin-left: 10px;
        color: #999999;
      }
    }
    .unload-content {
      .img-uploader {
        width: 72px;
        height: 72px;
        border-radius: 3px 3px 3px 3px;
        border: 1px solid #d9d9d9;
        position: relative;
        overflow: hidden;
      }

      /deep/ .el-upload {
        width: 72px;
        height: 72px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none !important;
        border-radius: 3px !important;
      }

      /deep/ .el-upload-list--picture-card .el-upload-list__item {
        width: 100%;
        height: 72px;
        border: none;
        background-color: #fff;
        border-radius: 3px !important;
      }

      .hide-upload-btn {
        /deep/ .el-upload--picture-card {
          display: none !important;
        }
      }

      .unload-tip {
        font-size: 12px;
        color: #999999;
        flex-direction: column;
        align-items: flex-start;
        margin-left: 20px;
        line-height: 18px;
      }
    }
  }
}

.preview-dialog {
  /deep/ .el-dialog__header {
    display: none !important;
  }
  /deep/.el-dialog__body {
    padding: 0px !important;
    border-radius: 8px !important;
  }
  .img {
    border-radius: 8px;
  }
}

.foot {
    flex-shrink: 0;
    display: flex;
    width: 100%;
    align-items: center;
    position: absolute;
    bottom: 10px;
    justify-content: center;
    height: 98px;
    border-top: 1px solid #f6f6f6;
    .backBtn {
      margin-right: 20px;
      width: 98px;
      height: 32px;
      color: #666666;
      border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .keepBtn {
      width: 98px;
      height: 32px;
      border-radius: 3px;
      background-color: #fe4d45;
      color: #fff;
      &:hover {
        opacity: 0.9;
      }
    }
  }
</style>
